import React from "react";
import SectionLayout, { DocumentField } from "./SectionLayout";

const Documents = ({ loanRequest, user }) => {
  return (
    <SectionLayout title="Documents">
      <DocumentField
        label="Passport Photograph"
        url={user?.face_image || loanRequest.passport}
      />
      <DocumentField
        label="Government ID"
        url={user?.document_image || loanRequest?.government_id}
      />
      <DocumentField
        label="Utility Bill"
        url={loanRequest.utility_bill}
      />
      <DocumentField
        label="Bank Statement"
        url={loanRequest.bank_statement}
      />
      {loanRequest?.cac && (
        <DocumentField
          label="CAC"
          url={loanRequest.cac}
        />
      )}
    </SectionLayout>
  );
};

export default Documents;
